module.exports = __webpack_public_path__ + "img/changeStonegroup-1.a95614b.png";